

export const MOBILE_CODES = [
  '+65',
  '+84',
  '+61',
  '+66'
]

export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY